import { Cid } from '@/lib/mars'
import cookie from '@/utils/cookie'
// 保持全局唯一实例
import Vue from 'vue'
const vue = new Vue()

const util = {
	// 获取单例
	getInstance () {
		return vue
	},
	setHtmlFontSize() {
    if (this.isMobile()) {
      document.documentElement.style.fontSize = '13.3333333333333333vw'
    } else {
      document.documentElement.style.fontSize = '100px'
    }
	},
	setPCHtmlFontSize() {
		let clientWidth = window.innerWidth || document.body.clientWidth
    if (clientWidth >= 1600) {
      document.documentElement.style.fontSize = '1px'
    } else {
      clientWidth = clientWidth < 1000 ? 1000 : clientWidth
      document.documentElement.style.fontSize = clientWidth / 1600 + 'px'
    }
	},
	// 全局toast
	toast (msg, duration, callback) {
		vue.$emit('toast', msg, duration, callback)
	},
	// 节流函数，防止事件频繁触发函数被不断执行导致页面卡顿
	throttle (fn, interval = 30) {
		let timeout = null
		return (...args) => {
			if (timeout) {
				return true
			}
			else {
				timeout = setTimeout(() => {
					clearTimeout(timeout)
					timeout = null
				}, interval)
				return fn(...args)
			}
		}
	},
	isMobile () {
		return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
	},
	isWechat () {
		return /MicroMessenger/i.test(window.navigator.userAgent)
	},
	// 是否在微信小程序
	isWechatMP() {
		const ua = window.navigator.userAgent
		return (/micromessenger/i.test(ua) && /miniprogram/i.test(ua)) || window.__wxjs_environment === 'miniprogram'
	},
	isMobileWechat () {
		const na = window.navigator
		return /MicroMessenger/i.test(na.userAgent) && na.platform.indexOf('Win') < 0 && na.platform.indexOf('Mac') < 0
	},
	/* 表单验证
	 * 两种传参，一种传validate(rule, data)，一种传validate({rule: rule, data: data})
	 *	rule：规则
	 *	data：待验证的字符串
	 */
	validate (option, ...args) {
		let rule = null,
			data = null
		if (args.length > 0) {
			rule = option
			data = args[0]
		}
		else {
			rule = option.rule
			data = option.data
		}
		switch (rule) {
			// 中文验证
			case 'cn':
				return /^([\u4E00-\u9FA5]|[\uFE30-\uFFA0])$/.test(data)
			// 验证码不定位数，但一定是数字和字母的组合，并且不止一位
			case 'captcha':
				return /^\w+$/.test(data)
			case 'email':
				return /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(data)
			// 身份证，17位数字+最后一位为x或数字
			case 'idcard':
				/* eslint-disable max-len */
				return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(data)
			case 'mobile':
				return /^1\d{10}$/.test(data) || /^1[*\d]{10}$/.test(data)
			case 'number':
				return /^\d+$/.test(data)
			case 'password':
				// 数字、字母或符号，长度为6-20
				const test = !/(:?[^\x00-\xff]|\s)/.test(data) && /^.{6,20}$/.test(data)
				if (test) {
					// 两种以上的组合
					const count = /[a-zA-Z]/.test(data) + /[0-9]/.test(data) + /[^a-zA-Z0-9]/.test(data)
					if (count >= 2) {
						return true
					}
				}
				return false
			case 'url':
				return /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i.test(data)
			default:
				return data.length > 0
		}
	},
	// 打码规则，见http://wiki.corp.vipshop.com/pages/viewpage.action?pageId=241242268
	// todo
	mosaic (option, ...args) {
		let rule = null,
			data = null
		if (args.length > 0) {
			rule = option
			data = args[0]
		}
		else {
			rule = option.rule
			data = option.data
		}
		switch (rule) {
			default:
				return data
		}
	},
	// 中文转unicode编码
	cnToUnicode (str) {
		return str.replace(/([\u4E00-\u9FA5]|[\uFE30-\uFFA0])/g, ($1) => {
			return `\\u${$1.charCodeAt(0).toString(16)}`
		})
	},
	// todo
	unicodeToCn (str) {
	},
	// 格式化对象，把值为null或undefined的键去掉。当strict为true时过滤空对象和空字符串
	objectFilter (object, strict = false) {
		const obj = Object.assign({}, object)
		Object.keys(obj).forEach((key) => {
			if (obj[key] === undefined || obj[key] === null) {
				delete obj[key]
			}
			if (strict) {
				if (obj[key] === '' || ((typeof obj).toLowerCase() === 'object' && Object.keys(obj).length === 0)) {
					delete obj[key]
				}
			}
		})
		return obj
	},
	/* 日期格式化
	 * date：时间戳或date类型
	 * format：如yyyy-mm-dd hh:ii:ss。不区分大小写，位数任意
	 */
	dateFormat (date, format) {
		// 秒需要转成毫秒
		if (/^\d{10}$/.test(date)) {
			date = date * 1000
		}
		if (!(date instanceof Date)) {
			return util.dateFormat(new Date(date), format)
		}
		let result = format
		const o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'H+': date.getHours(),
			'i+': date.getMinutes(),
			's+': date.getSeconds(),
			'q+': Math.floor((date.getMonth() + 3) / 3),
		}
		// 匹配4位的年份
		if (/(y+)/i.test(result)) {
			result = result.replace(RegExp.$1, (date.getFullYear().toString()).substr(4 - RegExp.$1.length))
		}
		// 匹配2位或者1位的其他
		for (const key in o) {
			if (new RegExp(`(${key})`, 'i').test(result)) {
				result = result.replace(RegExp.$1, (RegExp.$1.length === 1)
					? (o[key])
					: ((`00${o[key]}`).substr(-2)))
			}
		}
		return result
	},
	paginationScroll (fn, offset = 30) {
		let body = document.body
		if (body.scrollTop === 0 && document.documentElement.scrollTop > 0) {
			body = document.documentElement
		}
		const max = body.scrollHeight - body.clientHeight - body.scrollTop
		if (max <= offset) {
			return fn()
		}
	},
	animate (current, target, interval, fn, frequency = 15) {
		const flag = current > target ? 1 : -1
		const step = (current - target) * frequency / interval
		let newValue = current
		let intervalFn = setInterval(() => {
			newValue = newValue - step
			if ((newValue - target) * flag < 0) {
				newValue = target
				clearInterval(intervalFn)
				intervalFn = null
			}
			fn(newValue)
		}, frequency)
		return {
			stop () {
				clearInterval(intervalFn)
				intervalFn = null
			}
		}
	},
	isAndroid () {
		const agent = window.navigator.userAgent
		return agent.indexOf('Android') > -1 || agent.indexOf('Adr') > -1
	},
	isIOS () {
		const agent = window.navigator.userAgent
		return !!agent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
	},
	getMarsCid() {
    let cid = cookie.get('mars_cid')
    if (!cid) {
      cid = Cid.creat()
      cookie.set('mars_cid', cid)
    }
    return cid
  },
}
export default util



// WEBPACK FOOTER //
// ./src/utils/index.js